var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3657 4.23441C13.5157 4.38443 13.5999 4.58788 13.5999 4.80001C13.5999 5.01214 13.5157 5.21559 13.3657 5.36561L6.96568 11.7656C6.81566 11.9156 6.61221 11.9998 6.40008 11.9998C6.18795 11.9998 5.9845 11.9156 5.83448 11.7656L2.63448 8.56561C2.48876 8.41473 2.40812 8.21265 2.40994 8.00289C2.41177 7.79313 2.4959 7.59248 2.64423 7.44416C2.79255 7.29583 2.9932 7.2117 3.20296 7.20987C3.41272 7.20805 3.6148 7.28869 3.76568 7.43441L6.40008 10.0688L12.2345 4.23441C12.3845 4.08444 12.588 4.00018 12.8001 4.00018C13.0122 4.00018 13.2157 4.08444 13.3657 4.23441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.f346699dde70633677118b3a76649fa1.svg";
export { ForwardRef as ReactComponent };